/**
 * support_settings_controller.js — saves the support timing settings on the
 * admin support page (Stimulus identifier support-settings).
 *
 * Bound to the settings form in templates/admin/support_inbox.html. Sends the
 * form's number inputs to PUT /api/support/settings and shows "Saved" or the
 * server's message per field. The bounds are the server's
 * (SupportService.update_settings); the form states none of its own.
 */
import { Controller } from "@hotwired/stimulus";
import { supportRequest } from "./_support_api.js";

export default class extends Controller {
    static targets = ['error', 'status'];
    static values = { url: String };

    // data-action="submit->support-settings#save"
    async save(event) {
        event.preventDefault();
        this._showErrors({});
        this.statusTarget.textContent = 'Saving...';
        const values = {};
        this.element.querySelectorAll('input[type=number]').forEach((input) => {
            values[input.name] = input.value === '' ? null : Number(input.value);
        });
        try {
            await supportRequest('', 'PUT', this.urlValue, JSON.stringify(values));
            this.statusTarget.textContent = 'Saved';
        } catch (error) {
            this.statusTarget.textContent = '';
            this._showErrors(error.details || {}, error.message);
        }
    }

    _showErrors(details, fallback) {
        this.errorTargets.forEach((target) => {
            const messages = details[target.dataset.field];
            target.textContent = Array.isArray(messages) ? messages.join(' ') : messages || '';
        });
        if (fallback && Object.keys(details).length === 0) this.statusTarget.textContent = fallback;
    }
}
